import {Component, Input, Output, OnInit, ViewChild, EventEmitter} from '@angular/core';
import {FilterType} from './filters-type.enum';
import {FiltersModel} from './filters.model';
import {IFilterOption, IFiltersConfig} from './filters-config.interface';
import {DropdownDirective} from '../dropdown/dropdown.directive';
import {animate, state, style, transition, trigger} from '@angular/animations';

type PaneType = 'left' | 'right';

@Component({
  selector: 'hxa-filters-collapsed',
  template: `<div class="hx-dropdown  ml-1 collapsedFilter" #dropdown="hx-dropdown"  hxaDropdown  [autoClose]="false" >
  <button id="collapsedFilterTrigger" type="button" class="hx-button hx-button-dropdown" hxaDropdownToggle>
    <span>{{(totalActiveFilters() > 0)? 'Filtered ('+totalActiveFilters()+')' : 'Filters' }}</span>
    <span class="hx-icon-control"><i class="icon icon-caret-down"></i></span>
  </button>
  <div class="hx-dropdown-menu has-limited-width collapsedFilter__menu panes" *hxaDropdownMenu>
    <ul class="panes__inner" [@slide]="activePane" (@slide.done)="onSlideDone($event)">
      <li id="filterSelections" class="panes__item">
        <ng-container *ngFor="let filter of data;trackBy: trackByFn;let lastItem = last;">

          <div class="hx-dropdown-header itemHeader">{{filter.label}}</div>

          <!-- single select -->
          <ng-container *ngIf="filter.type === FilterType.SingleSelect">
            <ul class="hx-list-group">
              <li>
                <a [id]="filter?.id + '-trigger'" (click)="changeFilterSelection(filter)" title="{{filter.selected?.label}}">
                  <div class="hx-list-action" *ngIf="filter.selected?.icon">
                    <i class="{{filter.selected?.icon}}"></i>
                  </div>
                  <div class="hx-list-content pl-1 is-text-ellipsed is-text-weight-bolder">{{filter.selected?.label}}</div>
                  <div class="hx-list-action">
                    <i class="icon icon-angle-right"></i>
                  </div>
                </a>
              </li>
            </ul>
          </ng-container>

          <!-- search filter -->
          <div *ngIf="filter.type === FilterType.Search" class="pl-3 pr-4">
            <div [id]="filter.id"  class="hx-input-group">
              <i class="hx-icon icon-search mt-1"></i>
              <div class="hx-input-control my-0">
                <input class="hx-input"
                       type="search"
                       (input)="searchFilter(filter)"
                       [(ngModel)]="filter.value">
                <label class="hx-label"></label>
                <div class="hx-help"></div>
              </div>
              <div class="hx-input-actions" *ngIf="filter.value">
                <div class="hx-button-group">
                  <button class="hx-button is-flat" (click)="clearSearch(filter)"><span class="hx-icon-control"><i class="icon icon-close-empty"></i></span></button>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </li>
      <li id="filterOptions" class="panes__item">
        <div class="hx-toolbar is-xsmall">
          <button id="paneBack" class="hx-button is-flat" (click)="back()"><i class="hx-icon icon-arrow-left"></i></button>
          <span>{{selectedFilter?.label}}</span>
        </div>
        <ul [id]="selectedFilter?.id + '-options'" class="hx-list-group options">
          <li class="options__item"  *ngFor="let option of selectedFilter?.options;trackBy: trackByFn">
            <a hxaDropdownItem (click)="selectFilterOption(option)" title="{{option?.label}}">
              <div class="hx-list-action" *ngIf="option?.icon">
                <i class="{{option?.icon}}"></i>
              </div>
              <div class="hx-list-content pl-1 is-text-ellipsed">{{option?.label}}</div>
            </a>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</div>
`,
  styles: [`.collapsedFilter__menu.panes{width:15rem;overflow:hidden}.collapsedFilter__menu.panes .panes__inner{display:flex;list-style:none;padding:0;margin-top:0}.collapsedFilter__menu.panes .panes__item{min-width:15rem;max-width:15rem}.collapsedFilter__menu.panes .panes__item>ul{max-height:20rem;overflow-y:auto;overflow-x:hidden}.collapsedFilter__menu.panes .panes__item>ul>li:last-child:not(:first-child) a{border-bottom:none}`],
  animations: [
    trigger('slide', [
      state('left', style({ transform: 'translateX(0)' })),
      state('right', style({ transform: 'translateX(-100%)' })),
      transition('* => *', animate(200))
    ])
   ]
})
export class FiltersCollapsedComponent implements OnInit {

  @ViewChild('dropdown') dropdown: DropdownDirective;

  FilterType = FilterType;
  activePane = 'left';
  selectedFilter: FiltersModel;

  @Input() data: FiltersModel[] = [];

  @Output() onFilter = new EventEmitter();
  @Output() onSearchFilter = new EventEmitter();

  constructor() { }

  ngOnInit() {
  }

  clearSearch(filter: FiltersModel) {
    filter.value = '';
    this.onSearchFilter.emit({filter: filter, value: filter.value});
  }

  changeFilterSelection(filter: FiltersModel) {
    this.selectedFilter = filter;
    this.activePane = 'right';
  }

  selectFilterOption( option: IFilterOption) {
    this.onFilter.emit({filter: this.selectedFilter, option: option});
    this.back();
  }

  searchFilter(filter: FiltersModel) {
    this.onSearchFilter.emit({filter: filter});
  }

  back() {
    this.activePane = 'left';
  }

  onSlideDone($event) {
    if ($event.toState === 'left') {
      this.selectedFilter = null;
    }
  }

  totalActiveFilters(): number {
    let count = 0;
    this.data.forEach((filter: FiltersModel, index: number) => {
        if (!filter.isDefaultOptionActive()) {
          count++;
        }
    });
    return count;
  }


  /**
   * Used for track by and boost performance
   */
  trackByFn(index, action) {
    return index;
  }
}
